export default [
  {
    // T1006014 混合套餐兑换码改造，支持链接形式
    path: '/m/:code',
    name: 'mcl',
    meta: { title: '卡券兑换' },
    component: () => import('@/views/verifyV2')
  },
  {
    path: '/verifyV2',
    name: 'verifyV2',
    meta: { title: '卡券兑换' },
    component: () => import('@/views/verifyV2')
  },
  {
    path: '/verifyV2List',
    name: 'verifyV2List',
    meta: { title: '卡券详情' },
    component: () => import('@/views/verifyV2/list')
  },
  {
    path: '/verifyV2Crowded',
    name: 'verifyV2Crowded',
    meta: { title: '活动火爆' },
    component: () => import('@/views/verifyV2/crowded')
  }
]
